import type { AxiosInstance } from 'axios';

export function telemetryInterceptor(api: AxiosInstance): void {
  api.interceptors.request.use((config) => {
    config.headers['x-correlation-id'] = config.headers['x-correlation-id'] ?? crypto.randomUUID();
    return config;
  });
}
